import { createSlice } from '@reduxjs/toolkit';

// DOMAIN
import { Domain } from 'constant';

// MODEL
import { CheckInCheckOutCenterState, CheckInCheckOutStep } from 'model';

// REDUCER ACTION
import {
  changeCheckInCheckOutCenterLoading,
  changeCheckInCheckOutCenterShowSomethingWentWrong,
  setIndividualCheckInCheckOutData,
  setCheckInCheckOutStep,
  setAttendanceStatusTime,
  changeCheckInCheckOutCenterCountryCode,
  changeCheckInCheckOutCenterNRIC,
  changeCheckInCheckOutCenterPhoneNumber,
  changeCheckInCheckOutCenterVerificationType,
  changeCheckInCheckOutCenterEventList,
  changeCheckInCheckOutCenterSelectedEvent,
  changeCheckInCheckOutCenterCenterName,
  changeCheckInCheckOutCenterVolunteerType,
  changeCheckInCheckOutCenterOrganizations,
  changeCheckInCheckOutCenterVolunteerData
} from './reducers';

export const initialState: CheckInCheckOutCenterState = {
  loading: false,
  individualCheckInCheckOut: undefined,
  showSomethingWentWrong: false,
  attendanceStatusTime: undefined,
  step: CheckInCheckOutStep.NULL,
  countryCode: '',
  verificationType: undefined,
  phone: '',
  nric: '',
  eventList: [],
  selectedEvent: undefined,
  centerName: '',
  selectedVolunteerType: undefined,
  organizations: [],
  selectedOrganization: undefined,
  volunteerData: undefined
};

export const checkInCheckOutCenterSlice = createSlice({
  name: Domain.CheckInCheckOutCenter,
  initialState,
  reducers: {
    changeCheckInCheckOutCenterLoading,
    changeCheckInCheckOutCenterShowSomethingWentWrong,
    setIndividualCheckInCheckOutData,
    setCheckInCheckOutStep,
    setAttendanceStatusTime,
    changeCheckInCheckOutCenterCountryCode,
    changeCheckInCheckOutCenterNRIC,
    changeCheckInCheckOutCenterPhoneNumber,
    changeCheckInCheckOutCenterVerificationType,
    changeCheckInCheckOutCenterEventList,
    changeCheckInCheckOutCenterSelectedEvent,
    changeCheckInCheckOutCenterCenterName,
    changeCheckInCheckOutCenterVolunteerType,
    changeCheckInCheckOutCenterOrganizations,
    changeCheckInCheckOutCenterVolunteerData
  }
});

export default checkInCheckOutCenterSlice.reducer;
